import React from 'react';
import { motion } from 'framer-motion';
import { STRIPE_PAYMENT_LOCK_ARMED } from '../utils/stripeBilling';

type Props = {
    /** true = harte Sperre (nur wenn ARMED) */
    locked: boolean;
    /** Vorschau/Debug: Modal zeigen ohne zu sperren — normalerweise aus */
    preview?: boolean;
    onLogout?: () => void;
};

/**
 * Vollbild-Sperre bei Zahlungsstop.
 * Wird nur scharf, wenn STRIPE_PAYMENT_LOCK_ARMED=true und locked=true.
 */
const ZahlungsstopModal: React.FC<Props> = ({ locked, preview = false, onLogout }) => {
    if (!locked && !preview) return null;
    if (locked && !STRIPE_PAYMENT_LOCK_ARMED) return null;

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100050] bg-black/95 backdrop-blur-md flex flex-col items-center justify-center text-center p-6"
            role="alertdialog"
            aria-modal="true"
            aria-labelledby="zahlungsstop-title"
        >
            <div className="w-24 h-24 bg-red-500/15 rounded-full flex items-center justify-center mb-6 border border-red-500/40 shadow-[0_0_40px_rgba(239,68,68,0.35)]">
                <motion.div animate={{ scale: [1, 1.12, 1] }} transition={{ repeat: Infinity, duration: 1.6 }}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="48"
                        height="48"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#f87171"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
                        <line x1="12" y1="9" x2="12" y2="13" />
                        <line x1="12" y1="17" x2="12.01" y2="17" />
                    </svg>
                </motion.div>
            </div>
            <h2
                id="zahlungsstop-title"
                className="text-red-400 text-3xl font-black uppercase tracking-[0.18em] mb-3"
            >
                Zahlungsstop
            </h2>
            <p className="text-white text-lg font-bold uppercase tracking-widest mb-4">Zugang verweigert</p>
            <p className="text-slate-400 max-w-md text-sm leading-relaxed mb-8">
                Die letzte Abbuchung konnte nicht durchgeführt werden oder wurde rückgebucht.
                Bitte kontaktiere deinen PreisExpert-Coach, um den Zugang wieder freizuschalten.
            </p>
            {onLogout && (
                <button
                    type="button"
                    onClick={onLogout}
                    className="px-6 py-3 rounded-xl bg-red-600 hover:bg-red-500 text-white text-xs font-black uppercase tracking-widest border border-red-400/40"
                >
                    Abmelden
                </button>
            )}
            {!STRIPE_PAYMENT_LOCK_ARMED && preview && (
                <p className="mt-6 text-[10px] text-slate-600 uppercase tracking-widest">
                    Vorschau — Sperre noch nicht scharfgeschaltet
                </p>
            )}
        </motion.div>
    );
};

export default ZahlungsstopModal;
